import axios from 'axios';
import { addDays, format, parse, startOfDay } from 'date-fns';
import { DATE_FORMAT_ISO_DAY } from '../../constants/dateFormat';
import type { CalendarPublication } from './types';

export type FetchCalendarPublicationsArgs = Readonly<{
    isSsoUser: boolean;
    userId: number;
    fromDate: string;
    toDate: string;
    titleQuery?: string;
    status?: '1' | '2' | '-1';
    socialNetworks?: readonly string[];
}>;

function nextDay(ymd: string): string {
    return format(
        addDays(startOfDay(parse(ymd, DATE_FORMAT_ISO_DAY, new Date())), 1),
        DATE_FORMAT_ISO_DAY,
    );
}

export async function fetchPublicationsForCalendarRange({
    isSsoUser,
    userId,
    fromDate,
    toDate,
    titleQuery,
    status,
    socialNetworks,
}: FetchCalendarPublicationsArgs): Promise<readonly CalendarPublication[]> {
    const params = new URLSearchParams({
        pubDateSup: fromDate,
        pubDateInf: fromDate === toDate ? nextDay(toDate) : toDate,
        referer: 'page-publication',
    });
    if (titleQuery) {
        params.set('title', titleQuery);
    }
    if (status) {
        params.set('status', status);
    }
    const activeSocialNetworks = (socialNetworks ?? []).filter(Boolean);
    if (activeSocialNetworks.length === 1) {
        params.set('social', activeSocialNetworks[0]);
    }

    const path = isSsoUser
        ? `/api/publications-all-accessible-for-user/${userId}`
        : '/api/publications-all-accessible-for-admin';

    const { data } = await axios.get<readonly CalendarPublication[]>(`${path}?${params}`);
    return data;
}
